export default __webpack_public_path__ + "static/media/custom_task_icon.a012bf3d.svg";